// src/components/OfflineBanner.tsx
// ネットワーク切断時に画面上部へ通知バーを表示する。
// Web は navigator.onLine、Capacitor ネイティブは @capacitor/network が
// あればそれを優先して使用する（無ければ onLine にフォールバック）。
import React, { useEffect, useState } from 'react';
import { Box, Slide } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const OfflineBanner: React.FC = () => {
    const [online, setOnline] = useState<boolean>(
        typeof navigator !== 'undefined' ? navigator.onLine : true
    );

    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <Slide direction="down" in={!online} mountOnEnter unmountOnExit>
            <Box
                role="status"
                aria-live="polite"
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 2000,
                    bgcolor: '#b71c1c',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    py: 1,
                    px: 2,
                    fontSize: '0.85rem',
                    paddingTop: 'calc(8px + env(safe-area-inset-top))',
                }}
            >
                <WifiOffIcon fontSize="small" />
                オフラインです。通信環境をご確認ください。
            </Box>
        </Slide>
    );
};

export default OfflineBanner;
